import { Link } from 'react-router-dom';
import { services } from '@/mocks/home';

export default function Services() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            核心服务
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            一站式满足您的多元需求
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            六大核心服务板块，覆盖娱乐、购物、旅游、科技、生活等领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.href}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${service.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2.5">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {service.description}
              </p>
              <div className="mt-4 flex items-center gap-1.5 text-primary-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}